import { isBefore, isAfter, startOfDay, endOfDay } from 'date-fns';

import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { TYPE } from 'app/config/prescription_content';
import generateDates from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/generateDates';
import setTimePerSpecificTime from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/setTimePerSpecificTime';
import checksIfMatchesDayOfWeek from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/checksIfMatchesDayOfWeek';
import dateFormat from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/dateFormat';

const schedulePerWeekSpecificTime = function (padPrescription, pad) {
  const {
    /*     padPrescriptionId,
    instruction, */
    padPrescriptionSuggestionScheduling
    //
  } = padPrescription;

  // ***************************************************************************
  //                   GET PAD_PRESCRIPTION  INFORMATION
  // ***************************************************************************

  const { TIMES_PER } = CALENDAR_TYPE;

  const calendarType = TIMES_PER;
  const { /*  padId, */ description, type } = padPrescription;

  // ***************************************************************************
  //                   GET PAD INFORMATION
  // ***************************************************************************

  let { startDate, endDate } = pad;

  const padStartDate = startOfDay(startDate);
  const padEndDate = endOfDay(endDate);

  // ***************************************************************************
  //                           VALIDATE PAD_PRESCRIPTION TYPE
  // ***************************************************************************

  // FIXME avaliar necessidade dessa verificação

  const { SUSPENDED } = TYPE;

  const isPadPrescriptionSuspended = type === SUSPENDED;

  if (isPadPrescriptionSuspended) return;

  const now = new Date();
  const startDateToday = startOfDay(now);

  const {
    period,
    continuousUse,
    once
    // frequencyTypeId,
    // frequencyAmount,
    // frequency,
    // timeStart,
    // timeEnd,
  } = padPrescription;

  let dates = generateDates({
    period,
    continuousUse,
    once,
    startDate: startDateToday,
    endDate: padEndDate
  });

  dates = [...dates]
    // Removes date that are later than the padEndDate of Pad
    .filter(startDateTime => !isAfter(startOfDay(startDateTime), padEndDate))
    // Removes date that are before than the padStartDate of Pad
    .filter(startDateTime => !isBefore(startOfDay(startDateTime), padStartDate));

  // ***************************************************************************
  //                        SCHEDULE PRESCRIPTION CALENDAR
  // ***************************************************************************

  let perWeekSpecificTimeList = [];
  // eslint-disable-next-line
  for (const date of dates) {
    // eslint-disable-next-line
    for (let padPrescriptionSuggestion of padPrescriptionSuggestionScheduling) {
      const { dayOfWeek, applicationTime } = padPrescriptionSuggestion;

      const dateMatchDayOfWeek = checksIfMatchesDayOfWeek(date, dayOfWeek);

      if (dateMatchDayOfWeek) {
        const administrateDate = setTimePerSpecificTime(date, applicationTime);

        const insert = {
          //prescriptionContentId,
          calendarType,
          administrateDate,
          // shiftId,
          // administrateVisitationId,
          // aplicationDate,
          // aplicationVisitationId,
          // digitalSignature,
          // latitude,
          // longitude,
          description
        };

        perWeekSpecificTimeList.push(insert);
      }
    }
  }
  return dateFormat(perWeekSpecificTimeList);
};

export default schedulePerWeekSpecificTime;
